import { render, staticRenderFns } from "./LogAcesso.vue?vue&type=template&id=28ec5186&scoped=true"
import script from "./LogAcesso.vue?vue&type=script&lang=js"
export * from "./LogAcesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ec5186",
  null
  
)

export default component.exports